import { HudActions, HudEmitter } from '../Managers/Hud/HudEmitter';

export type PauseListener = (paused: boolean) => void;

export abstract class Pausable {
    public static isPaused: boolean = false;

    public static setPaused(paused: boolean) {
        if (Pausable.isPaused !== paused) {
            Pausable.isPaused = paused;
            HudEmitter.instance.emit(HudActions.SET_PAUSED, paused);
        }
    }

    private setPausedListener: PauseListener;

    protected constructor() {
        this.addListeners();
    }

    public destroy() {
        if (!this.setPausedListener) {
            return;
        }
        HudEmitter.instance.off(HudActions.SET_PAUSED, this.setPausedListener);
        this.setPausedListener = null;
    }

    protected addListeners() {
        if (this.setPausedListener) {
            return;
        }
        this.setPausedListener = this.setPaused.bind(this);
        HudEmitter.instance.on(HudActions.SET_PAUSED, this.setPausedListener);
    }

    protected abstract setPaused(paused: boolean): void;
}
